/*
    © 2021 EcomGraduates.com. All rights reserved.
    https://www.ecomgraduates.com
*/

// Init Wishlist
window.initWishlist = () => {
    const wishlist = JSON.parse(localStorage.getItem('eg_wishlist_v1')) || [];

    document.querySelectorAll('.btn-atw').forEach((btn) => {
        const isWishlisted = wishlist.some((product) => product.id === btn.dataset.productId);

        if (isWishlisted) {
            btn.title = btn.dataset.textRemoveFromWishlist;
            btn.classList.add('active');
        } else {
            btn.title = btn.dataset.textAddToWishlist;
            btn.classList.remove('active');
        }

        if (btn.getAttribute('data-bs-toggle')) {
            new bootstrap.Tooltip(btn); // eslint-disable-line no-new
        } else {
            btn.title = '';
        }
    });

    document.querySelectorAll('.wishlist-count-badge').forEach((el) => {
        el.textContent = wishlist.length;
        if (wishlist.length === 0) {
            el.style.display = 'none';
        } else {
            el.style.display = 'block';
        }
    });
};
window.initWishlist();

// Handle Wishlist Button
window.onClickWishlistBtn = (btn, event) => {
    event.preventDefault();

    if (btn.getAttribute('data-bs-toggle')) {
        bootstrap.Tooltip.getOrCreateInstance(btn).hide();
        bootstrap.Tooltip.getOrCreateInstance(btn).disable();
    }

    let wishlist = JSON.parse(localStorage.getItem('eg_wishlist_v1')) || [];

    if (wishlist.some((product) => product.id === btn.dataset.productId)) {
        wishlist = wishlist.filter((product) => product.id !== btn.dataset.productId);
        btn.title = btn.dataset.textAddToWishlist;
        btn.classList.remove('active');
    } else {
        wishlist.push({
            id: btn.dataset.productId,
            variant_id: btn.dataset.variantId,
            title: btn.dataset.productTitle.replace('"', ''),
            url: btn.dataset.productUrl,
            compare_at_price: btn.dataset.productCompareAtPrice,
            price: btn.dataset.productPriceFinal,
            price_varies: btn.dataset.productPriceVaries,
            img_src: btn.dataset.productImgSrc,
            img_alt: btn.dataset.productImgAlt,
            wishlisted_at: Date.now(),
        });
        btn.title = btn.dataset.textRemoveFromWishlist;
        btn.classList.add('active');
    }
    localStorage.setItem('eg_wishlist_v1', JSON.stringify(wishlist));

    if (btn.getAttribute('data-bs-toggle')) {
        new bootstrap.Tooltip(btn); // eslint-disable-line no-new
    } else {
        btn.title = '';
    }

    window.initWishlist();
};

// Load products in the wishlist section
const initWishlistSection = () => {
    const section = document.querySelector('.wishlist-section');

    if (!section) { return; }

    let wishlist = JSON.parse(localStorage.getItem('eg_wishlist_v1')) || [];

    if (wishlist.length > 0) {
        let html = '';
        wishlist.forEach((product) => {
            html += `
                <li class="product-list-item overflow-hidden p-3 p-lg-4">
                    <a href="${product.url}" class="img-wrapper d-block position-relative mb-4 hover-effect-shine">
                        <img 
                            class="product-img img-fluid me-4 w-100"
                            src="${window.resizeImage(product.img_src || 'no-image.gif', section.dataset.imgSize, 'center')}"
                            alt="${product.img_alt}" 
                            width="${section.dataset.imgWidth}"
                            height="${section.dataset.imgHeight}"
                            loading="lazy">
                    </a>
                    <div class="text-center">
                        <h3 class="product-title title h6 mb-3">
                            <a class="text-decoration-none d-block text-ellipsis" href="${product.url}">
                                ${product.title}
                            </a>
                        </h3>
                        <div class="yotpo bottomLine mb-2" data-product-id="${product.id}"></div>
                        <p class="product-price mb-4">
                            <s class="product-price-compare opacity-60 me-1 ${product.compare_at_price > product.price ? '' : 'd-none'}">
                                <span class="visually-hidden">
                                    ${section.dataset.textOldPrice}
                                </span>
                                ${window.formatMoney(product.compare_at_price)}
                            </s>
                            <span class="product-price-final ${product.compare_at_price > product.price ? 'text-secondary' : ''}">
                                <span class="price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">
                                    ${section.dataset.textPriceFrom}
                                </span>
                                ${window.formatMoney(product.price)}
                            </span>
                        </p>
                        <a class="btn btn-primary mb-2" href="${product.url}">
                            Add to cart
                        </a>
                        <button 
                            class="wishlist-btn-remove btn btn-link w-100 btn-sm d-flex align-items-center justify-content-center mb-6 opacity-80" 
                            type="button"
                            data-product-id="${product.id}">
                            <svg class="dime-icon dime-icon-bin me-3 opacity-70" width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.20449 10.5296C7.20449 10.8344 6.9551 11.0838 6.6503 11.0838C6.34549 11.0838 6.09611 10.8344 6.09611 10.5296V4.98772C6.09611 4.68291 6.34549 4.43353 6.6503 4.43353C6.9551 4.43353 7.20449 4.68291 7.20449 4.98772V10.5296ZM4.43357 10.5296C4.43357 10.8344 4.18418 11.0838 3.87937 11.0838C3.57457 11.0838 3.32518 10.8344 3.32518 10.5296V4.98772C3.32518 4.68291 3.57457 4.43353 3.87937 4.43353C4.18418 4.43353 4.43357 4.68291 4.43357 4.98772V10.5296ZM9.69834 1.38548H6.65029C6.65029 0.620694 6.0296 0 5.26481 0C4.50003 0 3.87934 0.620694 3.87934 1.38548H0.831287C0.371308 1.38548 0 1.75679 0 2.21676C0 2.67674 0.371308 3.04805 0.831287 3.04805L1.31343 11.9899C1.355 12.7242 1.96184 13.3006 2.69891 13.3006H7.83072C8.56779 13.3006 9.17463 12.7242 9.2162 11.9899L9.69834 3.04805C10.1583 3.04805 10.5296 2.67674 10.5296 2.21676C10.5296 1.75679 10.1583 1.38548 9.69834 1.38548Z" fill="currentColor"></path>
                            </svg>
                            ${section.dataset.textRemoveFromWishlist}
                        </button>
                    </div>
                </li>
            `;
            section.querySelector('.wishlist-empty').style.display = 'none';
            section.querySelector('.product-list').innerHTML = html;
            section.querySelector('.product-list').style.display = 'flex';
        });
    } else {
        section.querySelector('.wishlist-empty').style.display = 'block';
        section.querySelector('.product-list').style.display = 'none';
    }

    // if (window.Yotpo) {
    //     const api = new Yotpo.API(yotpo);
    //     api.refreshWidgets();
    // }

    document.querySelectorAll('.wishlist-btn-remove:not(.init)').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            btn.classList.add('init');

            wishlist = wishlist.filter((product) => product.id !== btn.dataset.productId);
            localStorage.setItem('eg_wishlist_v1', JSON.stringify(wishlist));

            window.initWishlist();
            initWishlistSection();
        });
    });
};

initWishlistSection();
